module.exports = __webpack_public_path__ + "static/media/work-pass_correct.a6a011e5.png";